import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HighlighterPipe } from '../pipes/highlighter.pipe';
import { GoogleLoginComponent } from '../components/google-login/google-login.component';
import { MicrosoftLoginComponent } from '../components/microsoft-login/microsoft-login.component';
import { SkeletonComponent } from '../skeleton/skeleton.component';
import { KendoModule } from './kendo.module';
import { ApplicationDateComponent } from '../recruiting/applicants/application-date/application-date.component';
import { ApplicantsDownloaderComponent } from '../recruiting/applicant-information/applicants-downloader/applicants-downloader.component';
// import { ReactWrapperComponent } from '../components-react/reactWrapperComponent';

@NgModule({
  declarations: [
    HighlighterPipe,
    GoogleLoginComponent,
    MicrosoftLoginComponent,
    SkeletonComponent,
    ApplicationDateComponent,
    ApplicantsDownloaderComponent,
    // ReactWrapperComponent,
  ],
  imports: [
    CommonModule,
    KendoModule
  ],
  exports: [
    HighlighterPipe,
    GoogleLoginComponent,
    MicrosoftLoginComponent,
    SkeletonComponent,
    ApplicationDateComponent,
    // ReactWrapperComponent,
    ApplicantsDownloaderComponent
  ]
})
export class SharedModule { }
